<script>
  import { getContext, onMount } from "svelte";
  import { fly } from "svelte/transition";
  import { userStores } from "@stores/index.js";
  import { settingStores } from "@stores/settingStores.js";
  import { navigate } from "svelte-navigator";
  import {
    DataTable,
    Modal as DangerModal,
    Pagination,
  } from "carbon-components-svelte";
  import GroupCell from "./components/GroupCell.svelte";
  import EditIcon from "./svg/EditIcon.svelte";
  import Button from "../../../lib/components/Button.svelte";
  import SearchInput from "./components/SearchInput.svelte";
  import Modal from "../../../lib/components/Modal.svelte";
  import MultiSelect from "../../../lib/components/MultiSelect.svelte";
  import Header from "../../../lib/components/Header.svelte";
  import { SectionWrapper } from "paxray-components-svelte";

  import { fetchWithSession } from "lib/util/fetchWithSession.js";
  import UsersAddEditModal from "./components/UsersAddEditModal.svelte";

  const role = getContext("role");
  export let embedded = false;

  let baseHeaders = [
    { key: "username", value: "Name" },
    { key: "email", value: "E-Mail" },
    { key: "role", value: "Role" },
    { key: "teams", value: "Team(s)" },
    { key: "groups", value: "Permission(s)" },
    { key: "actions", value: "Actions" },
  ];
  let users = [];

  // let dangerModalOpen = false;
  let deleteUserModalOpen = false;
  let createUserModalOpen = false;
  let username = "";
  let useremail = "";
  let password = "";
  let deleteUserObj = "";
  let confirmPassword = "";
  let searchUser = undefined;
  let userRole = null;
  let deleteUserInput = "";
  let selectedGroups = [];
  let selectedTeams = [];
  let selectedUserId = null;
  let errorUserExist = "";
  let invalidUser = false;
  let regularUser = false;
  let userToDelete = "";
  let invalidPassword = false;
  let errorPassword = "";
  let page = 1;
  let pageSize = 10;

  let userToEdit;

  let nmodelers = 0;
  let nviewers = 0;
  let nadmins = 0;

  // let headers = regularUser
  //   ? baseHeaders

  $: ({ users, teams, groups } = $settingStores);
  $: nviewers = users.filter((user) => user.role === "viewer").length;
  $: nmodelers = users.filter((user) => user.role === "modeler").length;
  $: nadmins = users.filter((user) => user.role === "admin").length;
  $: filteredUsers = searchUser || users || [];
  $: visibleUsers = filteredUsers.slice((page - 1) * pageSize, page * pageSize);
  const { getUsers, removeUser } = settingStores;

  $: invalidUser = errorUserExist !== "";

  $: invalidPassword = errorPassword !== "";

  $: disabledModalButton = !(
    username &&
    useremail &&
    isValidEmail(useremail) &&
    userRole &&
    userRole !== "defaultRole"
  );

  $: checkPermissions($userStores?.groups);

  const onRemove = (row, cell) => {
    deleteUserObj = row;
    deleteUserModalOpen = true;
  };

  const onGroupEdit = (row, cell, group) => {
    console.log("onGroupEdit", row, cell, group);
  };

  const onSearch = (value) => {
    page = 1;
    if (users && value.detail) {
      const searchTerm = value.detail.toLowerCase();
      const filteredUsers = users.filter((user) => {
        return (
          (user.username && user.username.toLowerCase().includes(searchTerm)) ||
          (user.email && user.email.toLowerCase().includes(searchTerm)) ||
          (user.role && user.role.toLowerCase().includes(searchTerm)) ||
          (user.teams &&
            user.teams.some(
              (team) =>
                team &&
                typeof team === "string" &&
                team.toLowerCase().includes(searchTerm),
            ))
        );
      });
      searchUser = filteredUsers;
    } else {
      searchUser = undefined;
    }
  };

  const handleOpenEditModal = (row) => {
    // selectedUserId = row.id;
    // userRole = row.role;
    // selectedTeams = row.teams.map((g) => g.id);
    // selectedGroups = row.groups.map((g) => g.id);
    // username = row.name;
    // useremail = row.email;
    // password = "";
    userToEdit = {
      id: row.id,
      username: row.username,
      email: row.email,
      role: row.role,
      pwd_enabled: row.pwd_enabled,
      teams: row.teams.map((g) => g.id),
      groups: row.groups.map((g) => g.id),
      created_by_method: "pwd",
    };
    createUserModalOpen = true;
  };

  const handleOpenCreateModal = () => {
    // selectedUserId = null;
    // userRole = "defaultRole";
    // selectedTeams = [];
    // selectedGroups = [];
    // username = "";
    // useremail = "";
    // password = "";
    userToEdit = {
      username: null,
      email: null,
      role: "modeler",
      pwd_enabled: true,
      created_by_method: "pwd",
      //password: null,
      teams: [],
      groups: [groups.find((group) => group.text === "User")?.id].filter(Boolean),
    };
    createUserModalOpen = true;
  };

  function checkPermissions(groups) {
    if ($role?.role === "admin") return;
    let permissions = new Set();
    groups
      ?.map((group) => group.permissions)
      .forEach((perms) => {
        perms.forEach((p) => permissions.add(p));
      });
    permissions = Array.from(permissions);

    if ($userStores && permissions.length === 0) navigate("/app");
    else if ($userStores && !permissions.includes("manage_users"))
      navigate("/app/settings");
  }

  function isValidEmail(useremail) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(useremail);
  }

  function confirmDeleteUser() {
    fetchWithSession(
      `/api/authentication/settings/users/${deleteUserObj?.id}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ passwords: confirmPassword }),
      },
    )
      .then((res) => {
        if (res?.ok) {
          removeUser(deleteUserObj?.id);
        }
        deleteUserModalOpen = false;
        userToDelete = "";
      })
      .catch(() => {
        deleteUserModalOpen = false;
      });
  }

  function confirmUserExist(username) {
    return users.find((user) => user.username === username);
  }

  onMount(() => {
    if (!users || users.length === 0 || !users[0]?.groups) {
      getUsers();
    }
  });

  $$restProps;
</script>

{#if !embedded}
  <Header section="User Management" area="Settings" areaHref="/app/settings/" breadcrumb="User Management">
    <SearchInput placeholder="Search users..." on:search={onSearch} />
    <Button variant="secondary" iconLeft={true} setting={true} text="Add User" icon="plus" on:click={() => handleOpenCreateModal()} />
  </Header>
{/if}

<SectionWrapper fullscreen shrinkContent {embedded}>
<section slot="main">
  <div class="table_summary">
    <div class="kpi-box" class:warning={nviewers > 5}>
      <div class="kpi-value">{nviewers}/5</div>
      <div class="kpi-label">Viewers</div>
    </div>
    <div class="kpi-box" class:warning={nmodelers > 5}>
      <div class="kpi-value">{nmodelers}/5</div>
      <div class="kpi-label">Analysts</div>
    </div>
    <div class="kpi-box" class:warning={nadmins > 5}>
      <div class="kpi-value">{nadmins}/5</div>
      <div class="kpi-label">Admins</div>
    </div>
    {#if embedded}
      <div class="embedded-toolbar"><SearchInput placeholder="Search users..." on:search={onSearch} /><Button variant="secondary" iconLeft={true} setting={true} text="Add User" icon="plus" on:click={() => handleOpenCreateModal()} /></div>
    {/if}
  </div>
  <div>
    {#if users.length}
      <DataTable
        headers={baseHeaders}
        rows={visibleUsers}
        class="custom-table"
      >
        <svelte:fragment slot="cell" let:row let:cell>
          {#if cell.key === "teams" || cell.key === "groups"}
            <GroupCell {cell} />
          {:else if cell.key === "actions"}
            <div class="actions-cell">
              <button on:click={() => handleOpenEditModal(row)} class="edit-remove-btn"><EditIcon /></button>
              {#if !regularUser}
                <button on:click={() => onRemove(row, cell)} class="edit-remove-btn"><img src="/img/ui_icons/delete_forever.svg" alt="Delete" /></button>
              {/if}
            </div>
          {:else}
            {cell?.value || "-"}
          {/if}
        </svelte:fragment>
      </DataTable>
      <Pagination bind:page bind:pageSize totalItems={filteredUsers.length} pageSizes={[10, 25, 50]} />
    {/if}
  </div>
</section>
</SectionWrapper>


<Modal
  actions
  autowidth={true}
  preventCloseOnClickOutside
  bind:open={deleteUserModalOpen}
  modalHeading={`Delete User ${deleteUserObj?.username}`}
  primaryButtonText="Delete"
  primaryButtonAction={() => {
    userToDelete = deleteUserInput;
    confirmDeleteUser();
  }}
  width={653}
  on:close={() => {
    deleteUserInput = "";
    errorUserExist = "";
  }}
>
  <div class="deleteModalBody">
    Are you sure you want to delete the user: <span class="user-name"
      >{deleteUserObj?.username}</span
    >?
    <br />
    <span>This action cannot be undone.</span>
  </div>
</Modal>

{#if createUserModalOpen}
  <UsersAddEditModal
    user={userToEdit}
    bind:modalOpen={createUserModalOpen}
  ></UsersAddEditModal>
{/if}

<style>
  section {
    width: 100%;
  }
  .embedded-toolbar { display: flex; flex: 1; align-items: center; gap: var(--control-gap); margin: 0 !important; }
  .embedded-toolbar :global(.search-input) { flex: 1; min-width: 0; border-color: var(--pax-black); }
  .table_summary {
    display: flex;
    align-items: center;
    gap: var(--control-gap);
    margin-bottom: var(--control-gap);
  }

  .kpi-box {
    display: flex;
    flex-direction: column;
    background-color: var(--pax-white);
    border: 1px solid var(--pax-black);
    padding: 0.75rem 1rem;
    border-radius: 0.5rem;
  }

  .kpi-label {
    color: var(--pax-black);
    font-size: 0.85rem;
    line-height: 1.1;
  }

  .kpi-box {
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 0.25rem;
    min-width: 7rem;
    height: 3rem;
    box-sizing: border-box;
    white-space: nowrap;
  }

  .kpi-value {
    color: var(--pax-black);
    font-size: 1rem;
    font-weight: 600;
    line-height: normal;
  }

  .kpi-box.warning .kpi-value {
    color: red;
  }

  .edit-remove-btn {
    background: var(--pax-black);
    width: 30px;
    height: 30px;
    border-radius: 4px;
    display: grid;
    place-items: center;
  }
  .actions-cell { display: flex; align-items: center; gap: 0.35rem; }
  .actions-cell img { width: 15px; height: 15px; }
  :global(.custom-table th:last-child),
  :global(.custom-table td:last-child) { width: 1%; white-space: nowrap; text-align: left; }
  :global(.cross-plus-icon) {
    rotate: 45deg;
  }
  .deleteModalBody {
    padding: 23px 0px 23px 0px;
    font-family: Inter;
    font-size: 14px;
  }
  .deleteModalBody span {
    font-weight: 700;
  }
  .deleteModalBody :last-child {
    color: var(--pax-orange);
  }

  :global(.user_form_wrapper .bx--form-item .bx--label) {
    margin-top: 1.5rem !important;
  }

  :global(.deleteModalBody + .bx--text-input-wrapper--readonly svg) {
    display: none;
  }
</style>
